import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

//components
import { NewBackButton, NoticeIcon } from "../../../../components/svgs";
import { StyledText } from "../../../../components/common/basic";

// theme
import { useTheme, useTrivia } from "../../../../hooks";
import CountdownTimer from "../../mashupnwin/components/CountdownTimer";

const CarouselTimer = ({ onHandleIsTime, timeRemaining }) => {
  const { activeTrivia } = useTrivia();

  const { themeContext, theme } = useTheme();
  const now = new Date().getTime();

  let history = useHistory();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return (
    <MainHolder>
      <Children>
        <div
          style={{
            width: "95%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <BackButtonContainer
            onClick={() => {
              history.goBack();
            }}
            style={{ zIndex: 100, marginLeft: 20 }}
          >
            <NewBackButton />
          </BackButtonContainer>
          <StyledText>Fastest Finger</StyledText>
          <NoticeIcon
            fill="black"
            onClick={() => history.push("/fastest_finger/fastest_finger_tips")}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <StyledText style={{ fontFamily: "MTNRegular" }}>
            Prepare to join the Fastest Finger frenzy!
          </StyledText>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: background,
            marginInline: 20,
            alignItems: "center",
            borderRadius: 10,
            color: "white",
          }}
        >
          <StyledText>STARTS IN</StyledText>

          <div
            style={{
              fontFamily: "Digital Numbers Regular",
              fontSize: 50,
            }}
          >
            <CountdownTimer
              timeRemaining={timeRemaining}
              startTime={now}
              onHandleIsTime={onHandleIsTime}
              showBottomText={false}
            />
          </div>
        </div>
        <div
          style={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            // justifyContent: "space-between",
            alignSelf: "center",
          }}
        ></div>
      </Children>
    </MainHolder>
  );
};

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
`;

const HistoryContainer = styled.div`
  width: 80%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;

// const SearchContainer = styled.div`
// display: "flex";
// justify-content: "space-between";
// border: "1px solid #C8CBCB";
// padding: 15px;
// width: 80%;
// border-radius: 15;
// `;
export default CarouselTimer;
